/* eslint-disable */
console.log('🔥 key_campaigns_carousel loaded');
import 'jquery';
import Flickity from 'flickity';

const key_campaigns_carousel = (function() {

  // Initialize Flickity carousel
  const init = () => {
    const carousel = document.querySelector('.KeyCampaigns-campaigns');
    if ( carousel ) {
      let flkty = new Flickity(carousel, {
  cellAlign: 'center',
  contain: true,
  wrapAround: true,
  pageDots: true, // ✅ explicitly enable
});
    }
  };

  return {
    init: init,
  };
})();

$(document).ready(function() {
  key_campaigns_carousel.init();
});
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/components/key_campaigns_carousel.js